// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import '@/assets/font/font.css';
import ElementUI from 'element-ui'
import './assets/css/theme/index.css' // ff9300


// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

const flag = navigator.userAgent.match(
  /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
);
let windowType = 'mobile'
if (flag) {
  // 手机端
  windowType = 'mobile'
} else {
  // pc端
  windowType = 'pc'
}
Vue.prototype.$WINDOWTYPE = windowType;

Vue.prototype.$axios = axios
Vue.config.productionTip = false
//获取用户登录状态
store.dispatch('auth/check_login')
store.dispatch("auth/loop_sync_login")
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
/* eslint-disable no-new */
const vueApp = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
import env from './env'

env.app = vueApp



// WEBPACK FOOTER //
// ./src/main.js